import { render } from "./profile_section.vue?vue&type=template&id=8cdbc030&ts=true"
import script from "./profile_section.vue?vue&type=script&lang=ts"
export * from "./profile_section.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__